module.exports = __webpack_public_path__ + "p7_img4.jpg?b3abe150b93ee32ce6e75ffdbadcf2ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p7/p7_img4.jpg
// module id = 129
// module chunks = 0